import { NgModule } from '@angular/core';
import { Routes, RouterModule, ActivatedRouteSnapshot } from '@angular/router';
import { InjectionToken } from '@angular/core';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { LoginHeatwaveComponent } from './main/authentication/login-heatwave/login-heatwave.component';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { RainfallActualComponent } from './main/side-bar/rainfall-actual/rainfall-actual.component';
// import { RainfallActualMisComponent } from './main/side-bar/rainfall-actual/rainfall-actual-mis/rainfall-actual-mis/rainfall-actual-mis/rainfall-actual-mis.component';
const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');

const routes: Routes = [

  // { path: 'rainfallactual/akbm', component: RainfallActualComponent },
  { path: '',  component: LoginHeatwaveComponent},
  { path: '*', component: PagenotfoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    {
      provide: externalUrlProvider,
      useValue: (route: ActivatedRouteSnapshot) => {
        // We get this param whenever we issue a routing request to an external url
        const externalUrl: any = route.paramMap.get('externalUrl');

        if (!isNullOrUndefined(externalUrl)) {
          // Open the new app in the same tab
          open(externalUrl, '_self');
        }
      }
    }
  ]
})
export class AppRoutingModule { }
